import Spinner from 'react-spinner-material';

const Loading = ({color = '#F59E0B', radius = 26, stroke = 2}) => (
  <Spinner radius={radius} color={color} stroke={stroke} visible />
);

export default Loading;
